/**
 * Greek Medical Terminology for PathGR
 * Comprehensive medical terms and localization for pathology professionals
 */

export const MEDICAL_TERMINOLOGY = {
  // General Medical Terms
  PATHOLOGY: 'Παθολογική Ανατομική',
  PATHOLOGIST: 'Παθολογοανατόμος',
  PATHOLOGISTS: 'Παθολογοανατόμοι',
  DIAGNOSIS: 'Διάγνωση',
  DIFFERENTIAL_DIAGNOSIS: 'Διαφορική διάγνωση',
  CLINICAL_HISTORY: 'Κλινικό ιστορικό',
  BIOPSY: 'Βιοψία',
  HISTOLOGY: 'Ιστολογία',
  IMMUNOHISTOCHEMISTRY: 'Ανοσοϊστοχημεία',
  CYTOLOGY: 'Κυτταρολογία',
  SPECIMEN: 'Δείγμα',
  TISSUE: 'Ιστός',
  
  // Medical Systems (used for both case types and areas of interest)
  MEDICAL_SYSTEMS: [
    'Οστά και μαλακά μόρια',
    'Θωρακική κοιλότητα',
    'Δέρμα',
    'Παιδιατρικό',
    'Παθ. Ανατομική του οφθαλμού',
    'Αιμολεμφικό',
    'Κεφαλή & Τράχηλος',
    'Γυναικολογικό',
    'Ουρογεννητικό',
    'Γαστρεντερικό',
    'Ενδοκρινικό και Νευροενδοκρινικό',
    'Κεντρικό Νευρικό σύστημα',
    'Μαστός',
	'Μοριακή Παθ. Ανατομική',
    'Κυτταρολογία',
    'Νεκροτομές'
  ],

  // Organ Systems
  ORGAN_SYSTEMS: {
    CARDIOVASCULAR: 'Καρδιαγγειακό σύστημα',
    RESPIRATORY: 'Αναπνευστικό σύστημα',
    GASTROINTESTINAL: 'Γαστρεντερικό σύστημα',
    GENITOURINARY: 'Ουρογεννητικό σύστημα',
    NERVOUS: 'Νευρικό σύστημα',
    ENDOCRINE: 'Ενδοκρινικό σύστημα',
    MUSCULOSKELETAL: 'Μυοσκελετικό σύστημα',
    INTEGUMENTARY: 'Δερματικό σύστημα',
    HEMATOPOIETIC: 'Αιμοποιητικό σύστημα',
    LYMPHOID: 'Λεμφοειδής ιστός'
  },

  // Staining Methods
  STAINING_METHODS: {
    HE: 'Αιματοξυλίνη-Ηωσίνη (H&E)',
    PAS: 'Περιοδικό οξύ Schiff (PAS)',
    TRICHROME: 'Τριχρωμικές χρώσεις',
    RETICULIN: 'Ρετικουλίνη',
    CONGO_RED: 'Κόκκινο του Κονγκό',
    PRUSSIAN_BLUE: 'Πρωσσικό μπλε',
    ALCIAN_BLUE: 'Αλκιανό μπλε',
    VAN_GIESON: 'Van Gieson',
    ELASTIN: 'Ελαστίνη',
    SILVER_STAIN: 'Αργυρική χρώση'
  },

  // Urgency Levels
  URGENCY_LEVELS: {
    LOW: 'Εκπαιδευτικό Υλικό',
    NORMAL: 'Κανονική προτεραιότητα',
    HIGH: 'Υψηλή προτεραιότητα',
    URGENT: 'Επείγον',
    STAT: 'Άμεσα απαιτούμενο'
  },

  // Case Status
  CASE_STATUS: {
    OPEN: 'Ανοιχτό',
    UNDER_REVIEW: 'Υπό εξέταση',
    PENDING_CONSULTATION: 'Εκκρεμεί συμβουλευτική',
    RESOLVED: 'Επιλυμένο',
    ARCHIVED: 'Αρχειοθετημένο',
    DELETED: 'Διαγραμμένο'
  },

  // Professional Titles
  PROFESSIONAL_TITLES: {
    DR: 'Δρ.',
    PROF: 'Καθ.',
    ASSOC_PROF: 'Αναπλ. Καθ.',
    ASST_PROF: 'Επίκ. Καθ.',
    RESIDENT: 'Ειδικευόμενος/η',
    CONSULTANT: 'Σύμβουλος',
    CHIEF: 'Διευθυντής/ντρια'
  },

  // Hospital Types
  HOSPITAL_TYPES: {
    UNIVERSITY: 'Πανεπιστημιακό Νοσοκομείο',
    GENERAL: 'Γενικό Νοσοκομείο',
    SPECIALIZED: 'Ειδικό Νοσοκομείο',
    PRIVATE: 'Ιδιωτική Κλινική',
    ONCOLOGY: 'Ογκολογικό Κέντρο',
    CHILDRENS: 'Παιδικό Νοσοκομείο'
  },

  // Interface Elements
  INTERFACE: {
    UPLOAD_CASE: 'Υποβολή Περιστατικού',
    REVIEW_CASE: 'Εξέταση Περιστατικού',
    SUBMIT_OPINION: 'Υποβολή Γνώμης',
    CASE_IMAGES: 'Εικόνες Περιστατικού',
    CLINICAL_DATA: 'Κλινικά Δεδομένα',
    MICROSCOPIC_DESCRIPTION: 'Μικροσκοπική Περιγραφή',
    MACROSCOPIC_DESCRIPTION: 'Μακροσκοπική Περιγραφή',
    FINAL_DIAGNOSIS: 'Τελική Διάγνωση',
    COMMENT: 'Σχόλιο',
    PROFESSIONAL_OPINION: 'Επαγγελματική Γνώμη',
    CASE_DISCUSSION: 'Συζήτηση Περιστατικού',
    EDUCATIONAL_VALUE: 'Εκπαιδευτική Αξία',
    RESEARCH_POTENTIAL: 'Ερευνητικό Ενδιαφέρον'
  },

  // Action Buttons
  ACTIONS: {
    SUBMIT: 'Υποβολή',
    SAVE_DRAFT: 'Αποθήκευση Προσχεδίου',
    PUBLISH: 'Δημοσίευση',
    EDIT: 'Επεξεργασία',
    DELETE: 'Διαγραφή',
    ARCHIVE: 'Αρχειοθέτηση',
    SHARE: 'Κοινοποίηση',
    DOWNLOAD: 'Λήψη',
    PRINT: 'Εκτύπωση',
    FAVORITE: 'Προσθήκη στα Αγαπημένα',
    FOLLOW: 'Παρακολούθηση',
    UNFOLLOW: 'Διακοπή Παρακολούθησης'
  },

  // Validation Messages
  VALIDATION: {
    REQUIRED_FIELD: 'Το πεδίο είναι υποχρεωτικό',
    INVALID_EMAIL: 'Μη έγκυρη διεύθυνση ηλεκτρονικού ταχυδρομείου',
    PASSWORD_TOO_SHORT: 'Ο κωδικός πρόσβασης πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
    PASSWORDS_NO_MATCH: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
    INVALID_PHONE: 'Μη έγκυρος αριθμός τηλεφώνου',
    FILE_TOO_LARGE: 'Το αρχείο είναι πολύ μεγάλο',
    INVALID_FILE_TYPE: 'Μη υποστηριζόμενος τύπος αρχείου',
    MAX_FILES_EXCEEDED: 'Υπέρβαση μέγιστου αριθμού αρχείων'
  },

  // Success Messages
  SUCCESS: {
    CASE_SUBMITTED: 'Το περιστατικό υποβλήθηκε επιτυχώς',
    OPINION_SUBMITTED: 'Η γνώμη σας υποβλήθηκε επιτυχώς',
    PROFILE_UPDATED: 'Το προφίλ σας ενημερώθηκε επιτυχώς',
    PASSWORD_CHANGED: 'Ο κωδικός πρόσβασης άλλαξε επιτυχώς',
    EMAIL_VERIFIED: 'Η διεύθυνση email επιβεβαιώθηκε επιτυχώς',
    CASE_ARCHIVED: 'Το περιστατικό αρχειοθετήθηκε επιτυχώς'
  },

  // Error Messages
  ERRORS: {
    NETWORK_ERROR: 'Σφάλμα δικτύου. Παρακαλώ δοκιμάστε ξανά.',
    SERVER_ERROR: 'Σφάλμα διακομιστή. Παρακαλώ επικοινωνήστε με την υποστήριξη.',
    ACCESS_DENIED: 'Δεν έχετε δικαίωμα πρόσβασης',
    CASE_NOT_FOUND: 'Το περιστατικό δεν βρέθηκε',
    USER_NOT_FOUND: 'Ο χρήστης δεν βρέθηκε',
    INVALID_CREDENTIALS: 'Μη έγκυρα διαπιστευτήρια',
    SESSION_EXPIRED: 'Η συνεδρία έχει λήξει. Παρακαλώ συνδεθείτε ξανά.',
    FILE_UPLOAD_FAILED: 'Η μεταφόρτωση αρχείου απέτυχε'
  },

  // Patient Demographics
  DEMOGRAPHICS: {
    AGE: 'Ηλικία',
    GENDER: 'Φύλο',
    MALE: 'Άνδρας',
    FEMALE: 'Γυναίκα',
    OTHER: 'Άλλο',
    UNKNOWN: 'Άγνωστο',
    YEARS_OLD: 'ετών',
    MONTHS_OLD: 'μηνών',
    DAYS_OLD: 'ημερών'
  },

  // Time and Dates
  TIME: {
    NOW: 'Τώρα',
    TODAY: 'Σήμερα',
    YESTERDAY: 'Χθες',
    TOMORROW: 'Αύριο',
    THIS_WEEK: 'Αυτή την εβδομάδα',
    LAST_WEEK: 'Την προηγούμενη εβδομάδα',
    THIS_MONTH: 'Αυτόν τον μήνα',
    LAST_MONTH: 'Τον προηγούμενο μήνα',
    MINUTES_AGO: 'λεπτά πριν',
    HOURS_AGO: 'ώρες πριν',
    DAYS_AGO: 'ημέρες πριν'
  },

  // Navigation
  NAVIGATION: {
    HOME: 'Αρχική',
    CASES: 'Περιστατικά',
    FORUM: 'Φόρουμ',
    ARCHIVE: 'Αρχείο',
    PROFILE: 'Προφίλ',
    SETTINGS: 'Ρυθμίσεις',
    HELP: 'Βοήθεια',
    LOGOUT: 'Αποσύνδεση',
    LOGIN: 'Σύνδεση',
    REGISTER: 'Εγγραφή'
  }
} as const;

// Greek month names
export const GREEK_MONTHS = [
  'Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος',
  'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος',
  'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'
];

// Greek day names
export const GREEK_DAYS = [
  'Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη',
  'Πέμπτη', 'Παρασκευή', 'Σάββατο'
];

// Medical abbreviations commonly used in Greek pathology
export const MEDICAL_ABBREVIATIONS = {
  'IHC': 'Ανοσοϊστοχημεία',
  'H&E': 'Αιματοξυλίνη-Ηωσίνη',
  'PAS': 'Περιοδικό οξύ Schiff',
  'PCR': 'Αλυσιδωτή αντίδραση πολυμεράσης',
  'WHO': 'Παγκόσμιος Οργανισμός Υγείας',
  'TNM': 'Σύστημα σταδιοποίησης TNM',
  'FISH': 'Φθορίζουσα in situ υβριδοποίηση',
  'NGS': 'Αλληλούχιση νέας γενιάς',
  'MSI': 'Αστάθεια μικροδορυφόρων',
  'MMR': 'Επιδιόρθωση δυσαντιστοίχισης'
};

// Greek pathology-specific formatting helpers
export const formatGreekText = (text: string): string => {
  // Ensure proper Greek text formatting
  return text.trim();
};

// Comprehensive gender-based medical role mappings
export const GENDERED_MEDICAL_ROLES = {
  'external_collaborator': {
    male: 'Εξωτερικός Συνεργάτης',
    female: 'Εξωτερική Συνεργάτις'
  },
  'resident_doctor': {
    male: 'Ειδικευόμενος Γιατρός',
    female: 'Ειδικευόμενη Γιατρός'
  },
  'specialist_doctor': {
    male: 'Ειδικός Γιατρός',
    female: 'Ειδική Γιατρός'
  },
  'professor': {
    male: 'Καθηγητής',
    female: 'Καθηγήτρια'
  }
} as const;

// Extended gender mappings for medical titles
export const GENDERED_TITLES = {
  'Δρ.': { male: 'Δρ.', female: 'Δρ.' },
  'Καθ.': { male: 'Καθ.', female: 'Καθ.' },
  'Αναπλ. Καθ.': { male: 'Αναπλ. Καθ.', female: 'Αναπλ. Καθ.' },
  'Επίκ. Καθ.': { male: 'Επίκ. Καθ.', female: 'Επίκ. Καθ.' },
  'Διευθυντής': { male: 'Διευθυντής', female: 'Διευθύντρια' },
  'Σύμβουλος': { male: 'Σύμβουλος', female: 'Σύμβουλος' },
  'Ειδικευόμενος': { male: 'Ειδικευόμενος', female: 'Ειδικευόμενη' },
  'Παθολογοανατόμος': { male: 'Παθολογοανατόμος', female: 'Παθολογοανατόμος' },
  'Γιατρός': { male: 'Γιατρός', female: 'Γιατρός' }
} as const;

export const formatMedicalTitle = (title: string, gender: 'male' | 'female' = 'male'): string => {
  // Format medical titles with proper Greek gender inflection
  const genderMapping = GENDERED_TITLES[title as keyof typeof GENDERED_TITLES];
  if (genderMapping) {
    return genderMapping[gender];
  }
  
  // Legacy mapping for backwards compatibility
  const legacyGenderMap = {
    'Δρ.': gender === 'female' ? 'Δρ.' : 'Δρ.',
    'Καθ.': gender === 'female' ? 'Καθ.' : 'Καθ.',
    'Διευθυντής': gender === 'female' ? 'Διευθύντρια' : 'Διευθυντής',
    'Ειδικευόμενος': gender === 'female' ? 'Ειδικευόμενη' : 'Ειδικευόμενος'
  };
  
  return legacyGenderMap[title as keyof typeof legacyGenderMap] || title;
};

// Gender-based user role mappings
export const GENDERED_USER_ROLES = {
  'member': {
    male: 'Μέλος',
    female: 'Μέλος'
  },
  'honorary_member': {
    male: 'Επίτιμο Μέλος',
    female: 'Επίτιμο Μέλος'
  },
  'moderator': {
    male: 'Συντονιστής',
    female: 'Συντονίστρια'
  },
  'admin': {
    male: 'Διαχειριστής',
    female: 'Διαχειρίστρια'
  }
} as const;

// Helper function to get gendered medical role by key
export const getGenderedMedicalRole = (
  medicalRole: keyof typeof GENDERED_MEDICAL_ROLES, 
  gender: 'male' | 'female' = 'male'
): string => {
  const roleMapping = GENDERED_MEDICAL_ROLES[medicalRole];
  return roleMapping ? roleMapping[gender] : medicalRole;
};

// Helper function to get gendered user role by key
export const getGenderedUserRole = (
  userRole: keyof typeof GENDERED_USER_ROLES, 
  gender: 'male' | 'female' = 'male'
): string => {
  const roleMapping = GENDERED_USER_ROLES[userRole];
  return roleMapping ? roleMapping[gender] : userRole;
};